// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cac34fa3","453":"690f0d42","455":"40c3311a","977":"09810c5d"}[chunkId] + ".chunk.js";
};